import { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Alert, Button, CircularProgress } from '@mui/material';
import { DesktopLayout } from 'src/layout';
import IntentService from 'src/services/IntentService';

/** Old bookmarks resolve to the original lead stream; no separate flows screen. */
export default function LegacyFlowRedirect() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const stream = params.get('stream');
    const draft = params.get('flow');
    const view = params.get('view');
    const anchor = view && ['funnel', 'business', 'knowledge'].includes(view) ? '#' + view : '';
    const [target, setTarget] = useState('');
    const [error, setError] = useState(false);
    const [retry, setRetry] = useState(0);
    useEffect(() => {
        let live = true;
        setTarget('');
        setError(false);
        if (stream || !draft) return;
        IntentService.list()
            .then(({ workspaces }) => {
                if (!live) return;
                const workspace = workspaces.find((w) => String(w.id) === draft);
                if (!workspace) {
                    setError(true);
                    return;
                }
                setTarget(
                    workspace.streams.length
                        ? '/leadstream/' + workspace.streams[0].id + anchor
                        : '/leadstream?draft=' + encodeURIComponent(draft)
                );
            })
            .catch(() => {
                if (live) setError(true);
            });
        return () => {
            live = false;
        };
    }, [stream, draft, anchor, retry]);
    if (stream && /^\d+$/.test(stream)) return <Redirect to={'/leadstream/' + stream + anchor} />;
    if (!draft) return <Redirect to="/leadstream" />;
    if (target) return <Redirect to={target} />;
    return (
        <DesktopLayout hideRightSidebar>
            {error ? (
                <Alert
                    severity="error"
                    action={<Button onClick={() => setRetry((n) => n + 1)}>Повторить</Button>}
                >
                    Не удалось открыть поток.
                </Alert>
            ) : (
                <CircularProgress size={24} />
            )}
        </DesktopLayout>
    );
}
